import { faCalendarLines } from "@fortawesome/pro-duotone-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Divider } from "@mui/material";
import { memo } from "react";
import { useNavigate } from "react-router-dom";
import { useAccessibility } from "../../../Store/contexts/AccessibilityContext";
import DefaultButton from "../../../components/Accessibility/DefaultButton";
import { ScheduleCardProps } from "../../../interfaces/props/SaudeOnline/ScheduleCardProps";
import ScheduleDetailFrame from "./ScheduleDetailFrame";
import { sxButtonScheduleAction, sxDividerScheduleCard } from "./sxProps";

const ScheduleCardGC: React.FC<ScheduleCardProps> = memo(({
  agendamento, handleClickCancelarAtendimento, handleClickEscolherOutroNumero, handleClickOpenModalInstrucoes
}) => {

  const navigate = useNavigate();
  const accessibility = useAccessibility();

  const getScheduleDateTimeViewFormat = (): string => {
    return agendamento.dataAgendamento + " " + agendamento.horaAgendamento + ":00";
  }

  const getCancellationDate = (): string | null => {
    return agendamento.status === 'cancelado' && agendamento.dataCancelamento !== null ? "em " + agendamento.dataCancelamento : null;
  }

  const isNullOrEmpty = (value: string) => {
    return value === null || value === "" ? true : false;
  }

  const disableJoin = (): boolean => {
    let enable = agendamento.statusTelemedicina === 'disponivel' && agendamento.statusTelemedicinaAPI === 'Iniciada';
    return !enable;
  }

  const handleClickIngressarNoAtendimento = () => {
    navigate(`/saudeOnline/ingressarNoAtendimento/${agendamento.idReuniao}`);
  }

  return (
    <div className='schedule-card' tabIndex={0} style={accessibility.contrastStyle}>
      <div>
        <FontAwesomeIcon style={accessibility.contrastColorAccessibility} icon={faCalendarLines} className='fadt-calendar-lines' />
      </div>
      <div className='schedule-card-details'>
        <ScheduleDetailFrame
          scheduleDetailKey={'medico'}
          scheduleDetailValue={agendamento.nomeMedico}
        />
        <ScheduleDetailFrame
          scheduleDetailKey={'especialidade'}
          scheduleDetailValue={agendamento.especialidade} />
        <ScheduleDetailFrame
          scheduleDetailKey={'endereco'}
          scheduleDetailValue={agendamento.endereco} />
        <ScheduleDetailFrame
          scheduleDetailKey={'telefone'}
          scheduleDetailValue={!isNullOrEmpty(agendamento.fonePrestador) ? agendamento.fonePrestador : '-'} />
        <Divider sx={sxDividerScheduleCard} />
        <ScheduleDetailFrame
          scheduleDetailKey={'dataHoraAgendamento'}
          scheduleDetailValue={getScheduleDateTimeViewFormat()} />
        <ScheduleDetailFrame
          scheduleDetailKey={'tipoAtend'}
          scheduleDetailValue={agendamento.descrTipoAtend} instrucoesDeAtendimento openModalInstrucoes={handleClickOpenModalInstrucoes} />
        <ScheduleDetailFrame
          scheduleDetailKey={'status'}
          scheduleDetailValue={agendamento.status}
          scheduleDetailAditionalValue={getCancellationDate()} />
        {(agendamento.permiteCancelarAgendamento || agendamento.permiteIngressarAtendimento || agendamento.status === 'cancelado') &&
          <div className='schedule-action-buttons-holder'>
            {/* TODO: FUNCIONALIDADE SERÁ MAPEADA COMO MELHORIA FUTURAMENTE
             {permiteEscolherOutroNumero && <DefaultButton
              type='button'
              variant='contained'
              sx={sxButtonScheduleAction}
              onClick={handleClickEscolherOutroNumero}
              text="Escolher outro número"
            />} */}
            {agendamento.permiteIngressarAtendimento && <DefaultButton
              type='button'
              variant='contained'
              disabled={disableJoin()}
              onClick={handleClickIngressarNoAtendimento}
              sx={sxButtonScheduleAction}
              text="Ingressar no Atendimento"
            />}
            {agendamento.permiteCancelarAgendamento && <DefaultButton
              type='button'
              variant='outlined'
              sx={{ ...sxButtonScheduleAction, border: '2px solid' }}
              onClick={handleClickCancelarAtendimento}
              style={accessibility.buttonStyleAccessibility}
              text="Cancelar Atendimento"
            />}
            {/* {agendamento.status === 'cancelado' && <DefaultButton
              type='button'
              variant='outlined'
              sx={{ ...sxButtonScheduleAction, border: '2px solid' }}
              onClick={() => { }}
              style={accessibility.buttonStyleAccessibility}
              text="Marcar novo atendimento"
            />} */}
          </div>}
      </div>
    </div>
  )
});

export default ScheduleCardGC;
